import "../../sass/header.scss";
import Logo from "./logo";

function HeaderHomepage() {
  const imgAutumn = "https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/master/bg-autumn.jpg"
  return (
    <div id={"header"} className={'header-homepage'} style={{backgroundImage: `url("${imgAutumn}")`}}>
      <Logo />
    </div>
  )
}

export default HeaderHomepage;
